import { Component, OnInit, HostListener, HostBinding, ViewChild, Input, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormGroup, FormControl, ControlValueAccessor, NG_VALUE_ACCESSOR, FormBuilder, AbstractControl, Validators, ValidatorFn } from '@angular/forms';
import { parse } from 'querystring';
import { CurrencyPipe } from '@angular/common';
import { StatusService } from 'src/app/core/services/status/status.service';

@Component({
  selector: 'advanced-checkbox-user',
  templateUrl: './advanced-checkbox-user.component.html',
  styleUrls: ['./advanced-checkbox-user.component.scss'],
  providers: [CurrencyPipe]
})
export class AdvancedCheckboxUserComponent implements OnInit {

  form: FormGroup;
  status: any;

  @Input() genericData;
  @Input() objectLevelOne;

  validationsList: any[] = [];

  _listItems: any;

  @Input()

  set listItems(value: any) {
    this._listItems = value;


    if (this._listItems) {
      this.form = this.createFormGroups();
    }

  }
  get listItems(): any {
    return this._listItems;
  }

  get value() {
    return this.form.value;
  }

  get sumOfAllValues(): number {
    let sum = 0;
    if (this.form) {      
      Object.values(this.form.controls).forEach((group: FormGroup) => {
        sum += isNaN(parseFloat(group.value.value)) ? 0 : parseFloat(group.value.value);
      });

    }
    return sum;
  }

  constructor(private fb: FormBuilder, private statusService: StatusService) {
    this.status = statusService.getCurrentObject();
  }

  ngOnInit(): void {
  }

  validations(item: any): Validators | null {
    let validList = [];

    if (item.porcentajeTotal) {
      const maxPorcentajeValue = parseFloat(this.objectLevelOne.valor) * parseFloat(item.porcentajeTotal);
      const type = this.genericData?.isAccessorie ? 'los accesorios' : 'las modificaciones';
      
      this.validationsList.push({
        id: item.id,
        name: 'max',
        message: `Lo sentimos, pero el valor máximo que aseguramos para ${type} de ${this.objectLevelOne.descriptionObject} es de ${maxPorcentajeValue.toFixed(maxPorcentajeValue % 1 && 2)} €`
      });

      validList = [...validList, Validators.max(maxPorcentajeValue)];
    }


    return Validators.compose(validList);
  }

  createFormGroups(): FormGroup {
    const group = this.fb.group({});

    this._listItems.forEach(field => {
      const control = this.fb.group({
        id: field.id,
        descriptionObject: field.alias,
        value: [field.value, this.validations(field)],
        porcentajeTotal: field.porcentajeTotal
      });

      group.addControl(field.id, control);

    });

    return group;
  }

}
